import { Text } from "@assetwatch/ui";

type RequestFieldLabelProps = {
  children: string;
  /** Associates the label with a control; renders a `<label>`. */
  htmlFor?: string;
  id?: string;
};

/**
 * Label for request fields that are not DS form inputs (priority group,
 * attachments, asset picker), so they read the same as the Input/Textarea
 * labels.
 */
export function RequestFieldLabel({
  children,
  htmlFor,
  id,
}: RequestFieldLabelProps) {
  /* @ds-deviation: the DS FieldLabel used by Input/Textarea is internal to @assetwatch/ui, so non-input fields compose its look from Text (body-medium, semibold) — export FieldLabel from @assetwatch/ui and use it here */
  const text = (
    <Text as="span" id={id} weight="semibold">
      {children}
    </Text>
  );
  return htmlFor ? <label htmlFor={htmlFor}>{text}</label> : text;
}
